import { ServiceDetailsComponent } from './service-details/service-details.component';
import { ServiceModalComponent } from './service-modal/service-modal.component';
import { ServiceRoutesDetailsComponent } from './routes/service-routes-details/service-routes-details.component';
import { ServiceRoutesModalComponent } from './routes/service-routes-modal/service-routes-modal.component';
import { ServiceRoutesRowComponent } from './routes/service-routes-row/service-routes-row.component';
import { ServiceRoutesSearchBarComponent } from './routes/service-routes-search-bar/service-routes-search-bar.component';
import { ServiceRowComponent } from './service-row/service-row.component';
import { ServiceSearchBarComponent } from './service-search-bar/service-search-bar.component';
import { RouteAlterationDetailsComponent } from './route-alterations/route-alteration-details/route-alteration-details.component';
import { RouteAlterationsComponent } from './route-alterations/route-alterations.component';
import { RouteDesignModalComponent } from './route-design/route-design-modal/route-design-modal.component';
import { RouteOrderedStopsComponent } from './route-design/route-ordered-stops/route-ordered-stops.component';
import { RouteDesignPreviewComponent } from './route-design/route-design-preview/route-design-preview.component';
import { RouteDesignToolbarComponent } from './route-design/route-design-toolbar.component';
import { RestrictionsComponent } from './restrictions/restrictions.component';
import { RestrictionDetailsComponent } from './restrictions/restriction-details/restriction-details.component';
import { RestrictionsSearchBarComponent } from './restrictions/restrictions-search-bar/restrictions-search-bar.component';

export {
  RestrictionDetailsComponent,
  RestrictionsComponent,
  RestrictionsSearchBarComponent,
  RouteAlterationDetailsComponent,
  RouteAlterationsComponent,
  ServiceDetailsComponent,
  ServiceModalComponent,
  ServiceRoutesDetailsComponent,
  ServiceRoutesModalComponent,
  ServiceRoutesRowComponent,
  ServiceRoutesSearchBarComponent,
  ServiceRowComponent,
  ServiceSearchBarComponent,
  RouteDesignToolbarComponent,
  RouteDesignModalComponent,
  RouteOrderedStopsComponent,
  RouteDesignPreviewComponent,
};

export const serviceComponents = [
  ServiceDetailsComponent,
  ServiceModalComponent,
  ServiceRoutesDetailsComponent,
  ServiceRoutesModalComponent,
  ServiceRoutesRowComponent,
  ServiceRoutesSearchBarComponent,
  ServiceRowComponent,
  ServiceSearchBarComponent,
  RouteDesignToolbarComponent,
  RouteDesignModalComponent,
  RouteOrderedStopsComponent,
  RouteDesignPreviewComponent,
  RouteAlterationDetailsComponent,
  RouteAlterationsComponent,
  RestrictionsComponent,
  RestrictionDetailsComponent,
  RestrictionsSearchBarComponent,
]
